import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const formControlLabel = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiFormControlLabel"] => ({
    root: {
        minHeight: spacing(3),
        marginLeft: "-4px",
        marginRight: "0",
    },
    label: {
        marginLeft: "0.4rem",
    },
});

export default formControlLabel;
